export enum PlanItemType {
    GEEN = 0,
    AFSPRAAK,
    STUDIEDAG,
    THEMADAG,
    TOETSPERIODE,
    VAKANTIE,
    NOTITIE,
}
